import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()(
  {
    component: () => (
      <div className="min-h-svh bg-background text-foreground">
        <Outlet />
      </div>
    ),
    notFoundComponent: () => (
      <div className="flex min-h-svh flex-col items-center justify-center gap-2">
        <p className="font-semibold text-2xl">404</p>
        <p className="text-muted-foreground text-sm">Esa página no existe.</p>
      </div>
    ),
  },
);
